import { FC } from "react";
import { formatDate, formatTime } from "shared/utils";
import type { SupportTicketMessage } from "../model/types";

import styles from "./TicketMessage.module.css";

interface Props {
  message: SupportTicketMessage;
}

export const TicketMessage: FC<Props> = ({ message }) => {
  const isOwn = message.author_type === "user";
  const createdAt = Date.parse(message.created_at);

  return (
    <div className={`${styles.message} ${isOwn ? styles.own : styles.support}`}>
      {!isOwn && <span className={styles.author}>Support</span>}
      <p className={styles.body}>{message.body}</p>
      <span className={styles.date}>
        {formatDate(createdAt)} {formatTime(createdAt)}
      </span>
    </div>
  );
};
